<template>
  <div v-if="filteredNotes.length"
       class="d-flex gap-2"
       :class="{ 'flex-column': !forceLine}">
    <div v-for="(n, nind) in filteredNotes"
         v-b-tooltip.hover
         :title="`${n.name}: ${n.description}`"
         class="patient-notes-block note-patient d-flex align-items-center"
         :class="{ 'important-note-patient': n.type, 'not-important-note-patient': !n.type }"
         :key="`note-${nind}`">
        <span style="font-size: 0"
              class="align-middle">
        <WarningSvg class="svg-size-sm mr-1"
                    :class="{ 'svg-warning': n.type, 'svg-black': !n.type }"/>
        </span>
      <span class="ml-1 note-description">{{ n.name }}: {{ n.description }}</span>
    </div>
  </div>
</template>

<script setup>
import { computed } from "vue"
import WarningSvg from "@/assets/svg-vue/general/warning.svg.vue"

const props = defineProps({
  notes: {
    type: Array,
    default: () => []
  },
  onlyImportant: {
    type: Boolean,
    default: false
  },
  forceLine: {
    type: Boolean,
    default: false
  }
})

const filteredNotes = computed(() => {
  if (props.onlyImportant) {
    return props.notes.filter(n => n.type)
  }
  return props.notes
})
</script>

<style lang="scss" scoped>
.patient-notes-block {
  overflow: hidden;
  line-height: 32px;
}
//important-note-patient
</style>
